import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatExpansionPanel } from "@angular/material";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.css"],
})
export class ConfirmDialogComponent implements OnInit {
  @ViewChild("freezePanel") freezePanel!: MatExpansionPanel;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    protected dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {}

  ngOnInit(): void { }

  onMainHeaderClose() {
    this.freezePanel.open();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
